import React from 'react';
import { Link } from "react-router-dom"; 

function Homelink () {
  return (
    <>
      <Link to="/">Home</Link>
    </>
  );
}

export default Homelink;